import React, {useMemo, useCallback, useState} from "react";
import {ProgressiveImageLoader} from "../../components/ProgressiveImageLoader.jsx";
import "./marketplace-subproduct-item.css";
import {highlightText} from "./utils.jsx";
import {Images} from "../../images/Images.jsx";
import common from "@well-b/well-b-shared";
import {FoodRequestToIcon} from "../OrderFormModularProductsPanel/consts.jsx";
import {Tooltip} from "antd";
import {FoodRequestsShortIdToName} from "../ProductsFilterModal/consts.jsx";
import {NOOP} from "../../utils/NOOP.jsx";
import {ModularProductDetailsModal} from "../OrderFormModularProductsPanel/ModularProductDetailsModal.jsx";

export const MarketplaceSubProductItem = ({
    content,
    searchText = "",
    onContentClick = NOOP,
    onNewTab,
    services,
    me
}) => {
    const [selectedSubProduct, setSelectedSubProduct] = useState(null);

    const matchingSubProducts = content?.provider?.subProducts || [];

    const fromPrice = useMemo(() => {
        return content?.service?.pricingTable?.byModular?.minPrice;
    }, [content?.service?.pricingTable?.byModular?.minPrice]);

    const onSubProductClick = useCallback(
        e => {
            e?.stopPropagation();
            onContentClick(content);
        },
        [onContentClick, content]
    );

    const onSubProductRowClick = useCallback((subProduct, e) => {
        e?.stopPropagation();
        setSelectedSubProduct(subProduct);
    }, []);

    const closeModal = useCallback(() => {
        setSelectedSubProduct(null);
    }, []);

    return (
        <div className="marketplace-subproduct-card">
            <div className="marketplace-subproduct-header" onClick={onSubProductClick}>
                <span className="marketplace-subproduct-link">
                    <img className="marketplace-subproduct-provider-image" src={content?.provider?.imageUrl} />
                </span>
                <div>
                    <div className="marketplace-subproduct-brand">
                        {content?.service?.brandName || content?.service?.engBrandName}
                    </div>
                    {content?.service?.productKosherType ? (
                        <div className="marketplace-subproduct-kosher">
                            ✡️ {common.product.ProductKosherTypesToHebrew[content.service.productKosherType]}
                        </div>
                    ) : (
                        <div className="marketplace-subproduct-kosher">ללא כשרות</div>
                    )}
                </div>
            </div>
            <div className="marketplace-subproduct-list">
                {matchingSubProducts?.map(subProduct => (
                    <div
                        key={subProduct?.id}
                        className="marketplace-subproduct-row"
                        onClick={e => onSubProductRowClick(subProduct, e)}>
                        <div className="marketplace-subproduct-thumb">
                            <ProgressiveImageLoader
                                src={subProduct?.subProductImage?.imageUrl || Images.services.generalImage}
                                width={subProduct?.subProductImage?.imageUrl ? 150 : 70}
                                height={subProduct?.subProductImage?.imageUrl ? 100 : 70}
                            />
                        </div>
                        <div className="marketplace-subproduct-text">
                            <div className="marketplace-subproduct-name">
                                {highlightText(subProduct?.name, searchText)} &nbsp;
                                {(subProduct?.foodRequests ?? []).map((foodOption, index) => {
                                    return (
                                        <Tooltip key={index} title={FoodRequestsShortIdToName[foodOption]}>
                                            <img
                                                key={index}
                                                className="marketplace-subproduct-food-request-image"
                                                src={FoodRequestToIcon[foodOption]}
                                                alt={foodOption}
                                                width={15}
                                                height={15}
                                            />
                                        </Tooltip>
                                    );
                                })}
                            </div>
                            {!!subProduct?.description && (
                                <div className="marketplace-subproduct-desc" title={subProduct?.description}>
                                    {highlightText(subProduct.description, searchText)}
                                </div>
                            )}
                            {!!subProduct?.price && (
                                <div className="marketplace-subproduct-price">₪ {subProduct.price} ליחידה</div>
                            )}
                        </div>
                    </div>
                ))}
            </div>
            <div className="marketplace-subproduct-footer" onClick={onSubProductClick}>
                {fromPrice != null && <span>מינ׳ הזמנה מהשותף: ₪ {fromPrice}</span>}
                <span>התחלת הזמנה &gt;&gt;</span>
            </div>
            {selectedSubProduct && (
                <ModularProductDetailsModal
                    open={!!selectedSubProduct}
                    onClose={closeModal}
                    product={selectedSubProduct}
                    showProviderSubProductsImages={true}
                />
            )}
        </div>
    );
};
